import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getUser, hasCredential, redirectionUrl, removeLastUrl, setLastUrl } from '../network/auth/Auth';

const ProtectedRoute: React.FC<{ children: JSX.Element, role: any, secure: boolean }> = ({ children, role }) => {
    console.log(role)
    const user = getUser();
    let defaultUrl = "/";
    if (user) {
        defaultUrl = redirectionUrl(user.roles);
    }

    const auth = hasCredential(role);

    const location = useLocation();
    if (!auth) {
        setLastUrl(location.pathname);
    } else {
        removeLastUrl();
    }

    //  return auth ? children : <Navigate to={{ pathname: defaultUrl }} />;

    return auth ? children : <Navigate to={{ pathname: defaultUrl }} />;
};

export default ProtectedRoute;
